export const SET_LOADER = "SET_LOADER";
export const SET_FORM_FLAG = "SET_FORM_FLAG";
export const SET_ISSUS_DETAILS = "SET_ISSUS_DETAILS";
export const SET_ISSUS_TYPE = "SET_ISSUS_TYPE";
export const SET_FORM_DATA = "SET_FORM_DATA";
export const SET_ISSUE_LIST = "SET_ISSUE_LIST";
export const SET_SEARCH_DATA = "SET_SEARCH_DATA";